import { KibContainer } from '@chewy/kib-layout-react/legacy';
import React from 'react';

import ConfirmationSheet from '@/components/navigation/ConfirmationSheet/ConfirmationSheet';
import styles from '@/pages/sign-up/Sign-Up.module.scss';

import { SignUpContent } from '../SignUpContent/SignUpContent';
import SignUpHeroSection from '../SignUpHeroSection/SignUpHeroSection';
import { StickyFreeTrialButton } from '../StickyFreeTrialButton/StickyFreeTrialButton';
import { StickyFreeTrialHeader } from '../StickyFreeTrialHeader/StickyFreeTrialHeader';

interface SignUpPageContentProps {
  signupV2Enabled: boolean;
  showWebExperience: boolean;
  handleStickyButtonClick: () => void;
  handleHeroButtonClick: () => void;
  handleAuthCheckAndConfirmationSheet: () => void;
  handleCloseSheet: () => void;
  showSheet: boolean;
  petProfiles: any[];
  timeZone?: string;
}

const SignUpPageContent: React.FC<SignUpPageContentProps> = ({
  signupV2Enabled,
  showWebExperience,
  handleStickyButtonClick,
  handleHeroButtonClick,
  handleAuthCheckAndConfirmationSheet,
  handleCloseSheet,
  showSheet,
  petProfiles,
  timeZone,
}) => (
  <div data-testid="sign-up-page">
    {signupV2Enabled && <StickyFreeTrialHeader onButtonClick={handleStickyButtonClick} />}
    <KibContainer className={styles.benefitsSection} data-testid="sign-up:cms-content">
      <SignUpHeroSection
        handleOpenConfirmationSheet={handleHeroButtonClick}
        petProfiles={petProfiles}
      />
      <SignUpContent
        onButtonClick={handleAuthCheckAndConfirmationSheet}
        petProfiles={petProfiles}
      />
    </KibContainer>
    <StickyFreeTrialButton onClick={handleStickyButtonClick} />
    <ConfirmationSheet
      handleClose={handleCloseSheet}
      showConfirmation={showSheet}
      showWebExperience={showWebExperience}
      timeZone={timeZone}
    />
  </div>
);

export default SignUpPageContent;
